import { render, staticRenderFns } from "./layout-project.vue?vue&type=template&id=2b933484&scoped=true"
import script from "./layout-project.vue?vue&type=script&lang=js"
export * from "./layout-project.vue?vue&type=script&lang=js"
import style0 from "./layout-project.vue?vue&type=style&index=0&id=2b933484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b933484",
  null
  
)

export default component.exports